import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { WrapperData, Wrapper } from 'modules/theme';
import SettingsSidebar from '../../sidebar';
import { Alert, confirm } from 'modules/theme';
import APIManager from 'modules/common/apiManager';
// import { Row } from 'modules/theme';
import { BarItems } from 'modules/theme';
import { DataWrapperClass } from '../styles';
import { FiTrash2 } from 'react-icons/fi';
import { PerPage } from 'helpers/system-config';
import { Col } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import {
    ModalFooter,
    FormWrapper,
    FormColumn,
    topHead,
    ColumnTitle,
    InfoWrapper
} from 'modules/theme';
import {
    ModalTrigger,
    Pagination,
    Button,
    FormControl,
    ActionButtons,
    Table,
    Label,
    Tip,
    DataWithLoader,
    FormGroup,
    ControlLabel,
    ReportPagination,
    SeachForm,
    ImportFile
} from 'modules/theme';
import { MdOutlineAdd } from 'react-icons/md';
import { Row } from '../../main/styles';
import UserMapSkillAddEdit from './UserMapSkillAddEdit';

export class UserMapSkill extends Component {

    constructor(props) {
        super(props);

        this.mAPI = new APIManager();
        this.getList = this.getList.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.openModal = this.openModal.bind(this);
        this.state = {
            listData: [],
            listData1: [],
            loading: false,
            showHide: false,
        };
    }

    componentDidMount() {
        this.getList();
    }

    openModal(data) {
        if (data) {
            this.setState({ showHide: true, editData: data });
        } else {
            this.setState({ showHide: true, editData: undefined });
        }
    }

    closeModal(isUpdated) {
        // console.log('isUpdated', isUpdated);
        this.setState({ showHide: false });
        // if (isUpdated) {
        this.getList();
        // }
    }

    getList() {
        console.log('state', this.state);
        var that = this;
        this.setState({ loading: true });
        let tData = {
            typeId: '7755e721-e952-4754-ae36-b0b8ffd0e58f',
            search: ''
        };
        let tData1 = {
            typeId: 'd63b18c9-6456-4cc0-8734-16f55526bd27',
            search: ''
        };
        this.mAPI.sendPostAPI(
            `setting-skill/type/list-all`,
            tData1,
            data => {
                that.setState({ loading: false });
                console.log(JSON.stringify(data, null, 2));
                if (data) {
                    that.setState({ listData1: data });
                } else {
                    that.setState({ listData1: [] });
                }
            },
            (error, data) => {
                that.setState({ loading: false });
                console.log(`Error:`, error);
                Alert.error('Error');
            }
        );

        this.mAPI.sendPostAPI(
            `setting-skill/type/list-all`,
            tData,
            data => {
                that.setState({ loading: false });
                console.log(JSON.stringify(data, null, 2));
                if (data) {
                    that.setState({ listData: data });
                } else {
                    that.setState({ listData: [] });
                }
            },
            (error, data) => {
                that.setState({ loading: false });
                console.log(`Error:`, error);
                Alert.error('Error');
            }
        );
    }

    renderActionBar() {
        const importTrigger = (
            <Button btnStyle="default" size="small">
                {/* <MdOutlineAdd /> */}
                <img src='/images/plus.png' />
            </Button>
        );
        return (
            <div>
                <Row
                    className="topHead"
                    style={{
                        paddingTop: '0px'
                    }}
                >
                    <Col>
                        <SeachForm>
                            <FormControl
                                type="text"
                                placeholder={'Search...'}
                                onChange={e => this.search(e)}
                                value={this.state.searchValue}
                                autoFocus={false}
                            />
                        </SeachForm>
                        {/* <FormWrapper>
                  <FormColumn>
                    <FormControl
                      style={{ borderRadius: '20px !important', padding: '0px' }}
                      type="text"
                      placeholder={'Type to search'}
                      onChange={e => this.search(e)}
                      value={this.state.searchValue}
                    />
                  </FormColumn>
                </FormWrapper> */}
                    </Col>

                    <Col>
                        <ModalTrigger
                            title={this.moduleName}
                            trigger={importTrigger}
                            size="md"
                            showHide={this.state.showHide}
                            closeModal={this.closeModal}
                            openModal={this.openModal}
                            dialogClassName={this.state.modalType}
                        >
                            <UserMapSkillAddEdit
                                size="small"
                                isEdit={true}
                                // editData={this.state.editData}
                                modalType={this.state.modalType}
                                listData={this.state.listData}
                                listData1={this.state.listData1}
                                closeModal={this.closeModal}
                            />
                        </ModalTrigger>
                    </Col>
                </Row>
            </div>
        );
    }

    render() {
        const { __ } = this.context;

        console.log('this.state.listData', this.state.listData);

        const mainContent = (
            <DataWrapperClass>
                <Table bordered hover>
                    <thead>
                        <tr>
                            <th>{__('name')}</th>
                            <th>{__('score')}</th>
                            {/* <th>{__('actions')}</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.listData.map(data => (
                            <tr key={data._id}>
                                <td className="text-primary">{data.name}</td>
                                <td>{data.score}</td>
                                {/* <td>{this.renderActions(data)}</td> */}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </DataWrapperClass>
        );

        const mainContent1 = (
            // <DataWrapperClass>
            <Table bordered hover>
                <thead>
                    <tr>
                        <th>{__('name')}</th>
                        <th>{__('score')}</th>
                        {/* <th>{__('actions')}</th> */}
                    </tr>
                </thead>
                <tbody>
                    {this.state.listData1.map(data => (
                        <tr key={data._id}>
                            <td className="text-primary">{data.name}</td>
                            <td>{data.score}</td>
                            {/* <td>{this.renderActions(data)}</td> */}
                        </tr>
                    ))}
                </tbody>
            </Table>
            // </DataWrapperClass>
        );

        return (
            <DataWrapperClass>
                <WrapperData
                    style={{ height: 'auto' }}
                    actionBar={
                        <Wrapper.ActionBar
                            left={
                                <div>
                                    <ControlLabel>Language</ControlLabel>
                                </div>
                            }
                            right={this.renderActionBar()}
                        />
                    }
                    content={mainContent}
                />

                <WrapperData
                    actionBar={
                        <Wrapper.ActionBar
                            left={
                                <div>
                                    <ControlLabel>Others</ControlLabel>
                                </div>
                            }
                            right={this.renderActionBar()}
                        />
                    }
                    content={mainContent1}
                />
            </DataWrapperClass>
        );
    }
}

UserMapSkill.contextTypes = {
    __: PropTypes.func
};

export default UserMapSkill


// WEBPACK FOOTER //
// src/modules/screens/settings/UserMapSkill/components/UserMapSkill.js